import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { JobIdProps } from "../interface/job_board";
import { AxiosErrorResponse } from "../interface/api_request";

export const apiGetAllRequest = async () => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/requests/facility`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetRequestById = async (id: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/requests/employee/${id}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiApproveMedicRequest = async (data: {
  id: string;
  status: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    formData.append("status", data.status);
    const uri = `/requests/request/${data?.id}`;
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetActiveJobs = async () => {
  try {
    const uri = `/jobs/medic`;
    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetJobId = async (data: JobIdProps) => {
  try {
    const uri = `/jobs/job/${data?.jobId}`;
    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateJobStatus = async (data: {
  status: string;
  jobId: string;
  token: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/jobs/update-status/${data.jobId}`;
    formData.append("status", data?.status);
    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${data?.token}`,
    });
    return await Axios.put(uri, formData.toString(), cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Job Stats
export const apiGetJobBoardStats = async (token: string) => {
  const token_key = token ?? "";

  try {
    const uri = `/jobs/stats`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token_key}`,
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
